export default __webpack_public_path__ + "static/media/generate-unique-id.b054eef1.svg";